import { useGetMembershipList } from '#api/member';
import { ScheduleMembership } from '#pages/WeeklyCalenderScheduleRegistration/LectureScheduleContents/useScheduleMembership';
import { Item } from './Item';

interface ItemListProps {
  personId?: string;
  onClick?: (params: ScheduleMembership) => void;
  // 수업중인 수강권만 보여줄지 여부
  isScheduling?: boolean;
}
export const ItemList = ({
  personId,
  onClick,
  isScheduling
}: ItemListProps) => {
  const sessionPersonId = sessionStorage.getItem('personId');

  const { data } = useGetMembershipList(personId || sessionPersonId || '');

  if (!data) {
    return null;
  }

  const filteredList = isScheduling
    ? data.data.memberships.filter(m => {
        const restRound = m.totalRound - m.completedRoundUntilNow;
        return calculatedLecture(restRound) !== '종료';
      })
    : data.data.memberships;

  return (
    <div>
      {filteredList.length === 0 && (
        <div className="w-full h-[102px] px-5 py-10 rounded-lg justify-center items-center gap-2.5 inline-flex">
          <div className="text-[#938f9e] text-[17px] font-medium font-['Pretendard Variable'] leading-snug">
            등록된 수강권이 없습니다
          </div>
        </div>
      )}

      {filteredList.length > 0 && (
        <div className="flex flex-col gap-12 w-full">
          {filteredList.map(membership => (
            <div
              key={membership.confirmationFormId}
              onClick={() => {
                if (onClick) {
                  onClick({
                    confirmationFormId: membership.confirmationFormId,
                    lectureName: membership.title,
                    lectureId: membership.lectureId,
                    completedRoundUntilNow: membership.completedRoundUntilNow,
                    totalRound: membership.totalRound
                  });
                }
              }}
            >
              <Item key={membership.lectureId} {...membership} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const calculatedLecture = (totalamount: number) => {
  if (totalamount > 3) {
    return '수업중';
  } else if (totalamount === 0) {
    return '종료';
  } else {
    return '종료임박';
  }
};
